import { applyAxiosInterceptors } from '@distribusion/portal-lib/api';
import { OryAuth } from '@distribusion/portal-lib/auth';
import { selectCurrentDomainConfig } from '@distribusion/portal-lib/cross-domain';
import axios from 'axios';
import config from 'config';

export const domainConfig = selectCurrentDomainConfig([config.distribusion, config.amtrak]);

const instance = axios.create({
  baseURL: domainConfig.apiUrl,
  withCredentials: true,
});

OryAuth.applyAuthInterceptors(instance);
applyAxiosInterceptors(instance);

export * from 'axios';
export default instance;
